<template>
  <div class="inside-right">
    <div class="inside-right-page" style="top: 0px">
      <div class="inside-fullSlide" v-if="superShow">
        <div class="bd">
          <div
            class="tempWrap"
            style="overflow: hidden; position: relative; width: auto"
          >
            <ul
              style="
                width: 1800px;
                position: relative;
                overflow: hidden;
                padding: 0px;
                margin: 0px;
                left: -1080px;
              "
            >
              <li class="clone" style="float: left; width: 360px" v-for="(picnew,index) in picnews" :key="index">
                <div class="pic" v-if="picnew.picsrc">
                  <a href="javascript:;"
                    ><img
                      :src="`/uploads/${picnew.picsrc}`"
                  /></a>
                </div>
                <div class="dl" v-if="picnew.picsrc">
                  <div class="dt">
                    <a
                      href="javascript:;"
                      :title="picnew.title"
                      >{{picnew.title}}</a
                    >
                  </div>
                  <div class="dd"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="hd">
          <ul>
            <li v-for="(picnew,index) in picnews" :key="index" class="">{{index+1}}</li>
          </ul>
        </div>
        <a class="prev" href="javascript:void(0)"></a>
        <a class="next" href="javascript:void(0)"></a>
      </div>

      <div class="inside-right-newsmore">
        <div class="head">
          <div class="ul flex-left">
            <div class="li selected" :data-url="`/news/views/${plate._id}`">
              {{plate.name}}
            </div>
          </div>
          <div class="more">
            <router-link :to="`/news/views/${plate._id}`">MORE</router-link>
          </div>
        </div>
        <div class="list2 show">
          <div class="piclist">
            <div class="list ellipsis">
              <div class="li title" v-for="(article,index) in articles" :key="index">
                <router-link
                  :to="`/news/info/${plate._id}/${article._id}`"
                  :title="article.title"
                  :style="`color: ${article.color?article.color:''}; font-weight: ${article.weight?article.weight:''}`"
                  >{{article.title}}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inside-right-newsmore">
        <div class="head">
          <div class="ul flex-left">
            <div class="li selected" :data-url="`/news/views/${plate2._id}`">
              {{plate2.name}}
            </div>
          </div>
          <div class="more">
            <router-link :to="`/news/views/${plate2._id}`">MORE</router-link>
          </div>
        </div>
        <div class="list2 show">
          <div class="piclist">
            <div class="list ellipsis">
              <div class="li title" v-for="(article,index) in articles2" :key="index">
                <router-link
                  :to="`/news/info/${plate2._id}/${article._id}`"
                  :title="article.title"
                  :style="`color: ${article.color?article.color:''}; font-weight: ${article.weight?article.weight:''}`"
                  >{{article.title}}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
  },
  data() {
    return {
      plate: {
        name: "新闻动态",
      },
      plate2: {
        name: "公示公告",
      },
      picnews: [],
      articles: [],
      articles2: [],
      superShow: true,
      global,
    };
  },
  mounted() {
    this.$axios
      .get("/api/articles?page=1&limit=10&picnews=1&sort=-createdAt")
      .then((res) => {
        if (res.data) this.picnews = this.global.sortByTop(res.data.data);
        this.$nextTick(function() {
          $(".inside-fullSlide").slide({
            titCell: ".hd ul",
            mainCell: ".bd ul",
            effect: "leftLoop",
            vis: "auto",
            autoPlay: true,
            autoPage: true,
            trigger: "click",
          });
          this.superShow = true;
        });
      });
    for (let i = 0; i < this.plates.length; i++) {
      if (this.plate.name == this.plates[i].name) {
        this.plate = this.plates[i];
      } else if (this.plate2.name == this.plates[i].name) {
        this.plate2 = this.plates[i];
      }
    }
    this.$axios
      .get(`/api/categorys/${this.plate._id}/articles?&sort=-createdAt`)
      .then((res) => {
        if (res.data)
          this.articles = this.global.sortByTop(res.data.data).slice(0, 6);
      });
    this.$axios
      .get(`/api/categorys/${this.plate2._id}/articles?&sort=-createdAt`)
      .then((res) => {
        if (res.data)
          this.articles2 = this.global.sortByTop(res.data.data).slice(0, 6);
      });
    $(function() {
      $(window).scroll(function() {
        var wnav2 = 0; //$('.wnav2').height(); //无需顶部悬浮导航，可以改成0
        var fixbox = $(".inside-right");
        var fixbox2 = $(".inside-right .inside-right-page");
        var offset = fixbox.offset();
        var p = $(window).scrollTop();
        if (p >= offset.top - wnav2 && !fixbox2.is(".selected")) {
          fixbox2.addClass("selected");
          fixbox2.css("top", wnav2 + "px");
        }
        if (p < offset.top - wnav2 && fixbox2.is(".selected")) {
          fixbox2.removeClass("selected");
        }

        var fixbox_height = $(".inside-right").height();
        var fixbox2_height = $(".inside-right .inside-right-page").height();
        if (
          p >= offset.top + fixbox_height - fixbox2_height - wnav2 &&
          !fixbox2.is(".selected2")
        ) {
          fixbox2.addClass("selected2");
          fixbox2.css("bottom", "0px");
          fixbox2.css("top", "auto");
        }
        if (
          p < offset.top + fixbox_height - fixbox2_height - wnav2 &&
          fixbox2.is(".selected2")
        ) {
          fixbox2.removeClass("selected2");
          fixbox2.css("bottom", "auto");
          fixbox2.css("top", wnav2 + "px");
        }
      });
    });
  },
  methods: {},
};
</script>

<style>
</style>
